// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   TutorialsDashboard.css  —  KinetiQ Tutorials Landing Page
   Udemy-inspired design: Inter font throughout, hover popup card
   ============================================================ */

   /* ─── Design Tokens ──────────────────────────────────────── */
   :root {
     --tdb-bg:            #f7f9fa;
     --tdb-surface:       #ffffff;
     --tdb-border:        #d1d7dc;
     --tdb-border-light:  #e8ecef;
     --tdb-accent:        #28a745;
     --tdb-accent-hover:  #1e8c3a;
     --tdb-accent-glow:   rgba(40, 167, 69, 0.15);
     --tdb-purple:        #5624d0;
     --tdb-purple-light:  rgba(86, 36, 208, 0.07);
     --tdb-purple-border: rgba(86, 36, 208, 0.18);
     --tdb-amber:         #b4690e;
     --tdb-amber-bg:      #f3e9d0;
     --tdb-text:          #1c1d1f;
     --tdb-text-muted:    #4a4f5a;
     --tdb-text-dim:      #6a6f73;
     --tdb-font:          'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
   }
   
   /* ─── Page wrapper ───────────────────────────────────────── */
   .tdb-page {
     background:  var(--tdb-bg);
     min-height:  100%;
     padding:     52px 64px 88px;
     font-family: var(--tdb-font);
     color:       var(--tdb-text);
     overflow-y:  auto;
     overflow-x:  hidden;
     box-sizing:  border-box;
     position:    relative;
     animation:   tdb-fadeIn 0.25s ease;
   }
   
   @keyframes tdb-fadeIn {
     from { opacity: 0; transform: translateY(8px); }
     to   { opacity: 1; transform: translateY(0); }
   }
   
   /* ─── Page header ────────────────────────────────────────── */
   .tdb-header {
     max-width:      900px;
     margin-bottom:  36px;
     border-bottom:  2px solid var(--tdb-text);
     padding-bottom: 20px;
   }
   
   .tdb-header-tag {
     font-family:    var(--tdb-font);
     font-size:      13px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--tdb-purple);
     margin-bottom:  10px;
   }
   
   .tdb-header-title {
     font-family:     var(--tdb-font);
     font-size:       32px;
     font-weight:     800;
     color:           var(--tdb-text);
     margin-bottom:   12px;
     line-height:     1.2;
     letter-spacing:  -0.5px;
   }
   
   .tdb-header-desc {
     font-family: var(--tdb-font);
     color:       var(--tdb-text-muted);
     font-size:   16px;
     font-weight: 400;
     line-height: 1.7;
     max-width:   640px;
     margin:      0;
   }
   
   /* ─── Card grid ──────────────────────────────────────────── */
   .tdb-grid {
     display:               grid;
     grid-template-columns: repeat(3, 1fr);
     gap:                   20px;
   }
   
   /* ─── Individual card ────────────────────────────────────── */
   .tdb-card {
     background:     var(--tdb-surface);
     border:         1px solid var(--tdb-border);
     border-radius:  6px;
     padding:        20px 20px 16px;
     cursor:         pointer;
     text-align:     left;
     display:        flex;
     flex-direction: column;
     gap:            12px;
     transition:     box-shadow 0.2s, transform 0.15s, border-color 0.15s;
     box-shadow:     0 2px 6px rgba(0, 0, 0, 0.06);
     font-family:    var(--tdb-font);
     color:          var(--tdb-text);
     appearance:     none;
     -webkit-appearance: none;
     border-style:   solid;
   }
   
   .tdb-card:hover,
   .tdb-card--active {
     box-shadow:   0 8px 28px rgba(0, 0, 0, 0.13);
     transform:    translateY(-4px);
     border-color: var(--tdb-purple);
   }
   
   .tdb-card:focus-visible {
     outline:        2px solid var(--tdb-accent);
     outline-offset: 3px;
   }
   
   .tdb-card-top {
     display:         flex;
     align-items:     flex-start;
     justify-content: space-between;
   }
   
   .tdb-card-icon {
     font-size:       22px;
     background:      #f3f4fd;
     border:          1px solid #ddd6f8;
     border-radius:   6px;
     width:           48px;
     height:          48px;
     display:         flex;
     align-items:     center;
     justify-content: center;
     flex-shrink:     0;
   }
   
   .tdb-card-arrow {
     width:           32px;
     height:          32px;
     border-radius:   50%;
     background:      var(--tdb-accent);
     color:           #fff;
     display:         flex;
     align-items:     center;
     justify-content: center;
     font-size:       16px;
     font-weight:     700;
     flex-shrink:     0;
     transition:      background 0.2s, transform 0.2s;
   }
   
   .tdb-card:hover .tdb-card-arrow,
   .tdb-card--active .tdb-card-arrow {
     background: var(--tdb-accent-hover);
     transform:  translateX(3px);
   }
   
   .tdb-card-body { flex: 1 1; }
   
   .tdb-card-title {
     font-family:    var(--tdb-font);
     font-size:      17px;
     font-weight:    700;
     color:          var(--tdb-text);
     margin-bottom:  8px;
     line-height:    1.35;
     letter-spacing: -0.1px;
   }
   
   .tdb-card-desc {
     font-family: var(--tdb-font);
     font-size:   14px;
     font-weight: 400;
     color:       var(--tdb-text-muted);
     line-height: 1.65;
     margin:      0;
   }
   
   .tdb-card-footer {
     border-top:  1px solid var(--tdb-border-light);
     padding-top: 12px;
     margin-top:  2px;
   }
   
   .tdb-card-tag {
     font-family:    var(--tdb-font);
     font-size:      12px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.8px;
     color:          var(--tdb-purple);
     background:     var(--tdb-purple-light);
     border:         1px solid var(--tdb-purple-border);
     border-radius:  4px;
     padding:        3px 10px;
   }
   
   /* ─── Hover Popup — Udemy-style ──────────────────────────── */
   .tdb-popup {
     position:      fixed;
     z-index:       1000;
     width:         340px;
     background:    var(--tdb-surface);
     border:        1px solid var(--tdb-border);
     border-radius: 6px;
     box-shadow:    0 4px 32px rgba(0, 0, 0, 0.18);
     padding:       20px;
     font-family:   var(--tdb-font);
     color:         var(--tdb-text);
     animation:     tdb-popupIn 0.15s ease;
     pointer-events: auto;
   }
   
   @keyframes tdb-popupIn {
     from { opacity: 0; transform: scale(0.97); }
     to   { opacity: 1; transform: scale(1); }
   }
   
   .tdb-popup-title {
     font-family:    var(--tdb-font);
     font-size:      18px;
     font-weight:    800;
     color:          var(--tdb-text);
     line-height:    1.3;
     letter-spacing: -0.3px;
     margin-bottom:  12px;
   }
   
   /* Badges row */
   .tdb-popup-badges {
     display:       flex;
     gap:           8px;
     margin-bottom: 12px;
     flex-wrap:     wrap;
   }
   
   .tdb-badge {
     font-family:    var(--tdb-font);
     font-size:      12px;
     font-weight:    700;
     border-radius:  4px;
     padding:        3px 9px;
     display:        inline-flex;
     align-items:    center;
     gap:            4px;
     letter-spacing: 0.2px;
   }
   
   .tdb-badge--premium {
     background: var(--tdb-purple);
     color:      #fff;
     border:     1px solid var(--tdb-purple);
   }
   
   .tdb-badge--bestseller {
     background: var(--tdb-amber-bg);
     color:      var(--tdb-amber);
     border:     1px solid #e0c080;
   }
   
   /* Meta rows */
   .tdb-popup-meta {
     font-family:   var(--tdb-font);
     font-size:     13px;
     font-weight:   400;
     color:         var(--tdb-text-muted);
     margin-bottom: 4px;
     line-height:   1.5;
   }
   
   .tdb-popup-meta strong {
     font-weight: 700;
     color:       var(--tdb-text);
   }
   
   .tdb-popup-meta--dim {
     color:         var(--tdb-text-dim);
     margin-bottom: 12px;
   }
   
   /* Short description */
   .tdb-popup-desc {
     font-family:   var(--tdb-font);
     font-size:     14px;
     font-weight:   400;
     color:         var(--tdb-text-muted);
     line-height:   1.65;
     margin-bottom: 14px;
   }
   
   /* Bullet list */
   .tdb-popup-bullets {
     list-style:    none;
     padding:       0;
     margin:        0 0 18px;
     display:       flex;
     flex-direction: column;
     gap:           9px;
   }
   
   .tdb-popup-bullets li {
     font-family:  var(--tdb-font);
     font-size:    13px;
     font-weight:  400;
     color:        var(--tdb-text-muted);
     line-height:  1.55;
     display:      flex;
     gap:          10px;
     align-items:  flex-start;
   }
   
   .tdb-popup-check {
     color:       var(--tdb-accent);
     font-weight: 700;
     font-size:   14px;
     flex-shrink: 0;
     margin-top:  1px;
   }
   
   /* CTA button — Udemy purple "Add to cart" style */
   .tdb-popup-cta {
     width:          100%;
     padding:        12px 16px;
     background:     var(--tdb-purple);
     color:          #fff;
     border:         none;
     border-radius:  4px;
     font-family:    var(--tdb-font);
     font-size:      15px;
     font-weight:    700;
     cursor:         pointer;
     text-align:     center;
     letter-spacing: 0.2px;
     transition:     background 0.2s, transform 0.1s;
   }
   
   .tdb-popup-cta:hover {
     background: #4019a8;
     transform:  translateY(-1px);
   }
   
   .tdb-popup-cta:active {
     transform: translateY(0);
   }
   
   /* ─── Responsive ─────────────────────────────────────────── */
   @media (max-width: 1100px) {
     .tdb-grid { grid-template-columns: repeat(2, 1fr); }
     .tdb-page { padding: 40px 40px 64px; }
   }
   
   @media (max-width: 640px) {
     .tdb-grid { grid-template-columns: 1fr; }
     .tdb-page { padding: 28px 20px 52px; }
     .tdb-header-title { font-size: 26px; }
     .tdb-header-desc  { font-size: 15px; }
     .tdb-card-title   { font-size: 16px; }
     .tdb-popup        { display: none; }
   }`, "",{"version":3,"sources":["webpack://./src/styles/TutorialsDashboard.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;GAI9D,+DAA+D;GAC/D;KACE,4BAA4B;KAC5B,4BAA4B;KAC5B,4BAA4B;KAC5B,4BAA4B;KAC5B,4BAA4B;KAC5B,4BAA4B;KAC5B,4CAA4C;KAC5C,4BAA4B;KAC5B,4CAA4C;KAC5C,4CAA4C;KAC5C,4BAA4B;KAC5B,4BAA4B;KAC5B,4BAA4B;KAC5B,4BAA4B;KAC5B,4BAA4B;KAC5B,uFAAuF;GACzF;;GAEA,+DAA+D;GAC/D;KACE,0BAA0B;KAC1B,iBAAiB;KACjB,2BAA2B;KAC3B,4BAA4B;KAC5B,4BAA4B;KAC5B,iBAAiB;KACjB,mBAAmB;KACnB,uBAAuB;KACvB,qBAAqB;KACrB,kCAAkC;GACpC;;GAEA;KACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;KAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;GAC/C;;GAEA,+DAA+D;GAC/D;KACE,qBAAqB;KACrB,oBAAoB;KACpB,yCAAyC;KACzC,oBAAoB;GACtB;;GAEA;KACE,+BAA+B;KAC/B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,mBAAmB;KACnB,iCAAiC;KACjC,oBAAoB;GACtB;;GAEA;KACE,gCAAgC;KAChC,qBAAqB;KACrB,oBAAoB;KACpB,gCAAgC;KAChC,qBAAqB;KACrB,oBAAoB;KACpB,uBAAuB;GACzB;;GAEA;KACE,4BAA4B;KAC5B,kCAAkC;KAClC,iBAAiB;KACjB,gBAAgB;KAChB,gBAAgB;KAChB,kBAAkB;KAClB,cAAc;GAChB;;GAEA,+DAA+D;GAC/D;KACE,2BAA2B;KAC3B,qCAAqC;KACrC,2BAA2B;GAC7B;;GAEA,+DAA+D;GAC/D;KACE,kCAAkC;KAClC,2CAA2C;KAC3C,mBAAmB;KACnB,8BAA8B;KAC9B,uBAAuB;KACvB,oBAAoB;KACpB,oBAAoB;KACpB,sBAAsB;KACtB,oBAAoB;KACpB,oEAAoE;KACpE,6CAA6C;KAC7C,+BAA+B;KAC/B,+BAA+B;KAC/B,oBAAoB;KACpB,wBAAwB;KACxB,qBAAqB;GACvB;;GAEA;;KAEE,4CAA4C;KAC5C,8BAA8B;KAC9B,+BAA+B;GACjC;;GAEA;KACE,2CAA2C;KAC3C,mBAAmB;GACrB;;GAEA;KACE,qBAAqB;KACrB,2BAA2B;KAC3B,8BAA8B;GAChC;;GAEA;KACE,qBAAqB;KACrB,wBAAwB;KACxB,kCAAkC;KAClC,oBAAoB;KACpB,qBAAqB;KACrB,qBAAqB;KACrB,qBAAqB;KACrB,uBAAuB;KACvB,uBAAuB;KACvB,kBAAkB;GACpB;;GAEA;KACE,qBAAqB;KACrB,qBAAqB;KACrB,oBAAoB;KACpB,kCAAkC;KAClC,qBAAqB;KACrB,qBAAqB;KACrB,uBAAuB;KACvB,uBAAuB;KACvB,qBAAqB;KACrB,oBAAoB;KACpB,kBAAkB;KAClB,gDAAgD;GAClD;;GAEA;;KAEE,mCAAmC;KACnC,2BAA2B;GAC7B;;GAEA,iBAAiB,SAAO,EAAE;;GAE1B;KACE,+BAA+B;KAC/B,oBAAoB;KACpB,mBAAmB;KACnB,+BAA+B;KAC/B,mBAAmB;KACnB,oBAAoB;KACpB,sBAAsB;GACxB;;GAEA;KACE,4BAA4B;KAC5B,iBAAiB;KACjB,gBAAgB;KAChB,kCAAkC;KAClC,iBAAiB;KACjB,cAAc;GAChB;;GAEA;KACE,8CAA8C;KAC9C,iBAAiB;KACjB,gBAAgB;GAClB;;GAEA;KACE,+BAA+B;KAC/B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,iCAAiC;KACjC,uCAAuC;KACvC,kDAAkD;KAClD,mBAAmB;KACnB,wBAAwB;GAC1B;;GAEA,+DAA+D;GAC/D;KACE,oBAAoB;KACpB,mBAAmB;KACnB,oBAAoB;KACpB,iCAAiC;KACjC,0CAA0C;KAC1C,kBAAkB;KAClB,6CAA6C;KAC7C,mBAAmB;KACnB,8BAA8B;KAC9B,8BAA8B;KAC9B,qCAAqC;KACrC,oBAAoB;GACtB;;GAEA;KACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;KAC3C,OAAO,UAAU,EAAE,mBAAmB,EAAE;GAC1C;;GAEA;KACE,+BAA+B;KAC/B,oBAAoB;KACpB,mBAAmB;KACnB,+BAA+B;KAC/B,mBAAmB;KACnB,sBAAsB;KACtB,oBAAoB;GACtB;;GAEA,eAAe;GACf;KACE,mBAAmB;KACnB,kBAAkB;KAClB,mBAAmB;KACnB,mBAAmB;GACrB;;GAEA;KACE,+BAA+B;KAC/B,oBAAoB;KACpB,mBAAmB;KACnB,mBAAmB;KACnB,uBAAuB;KACvB,2BAA2B;KAC3B,sBAAsB;KACtB,mBAAmB;KACnB,qBAAqB;GACvB;;GAEA;KACE,6BAA6B;KAC7B,gBAAgB;KAChB,uCAAuC;GACzC;;GAEA;KACE,+BAA+B;KAC/B,4BAA4B;KAC5B,6BAA6B;GAC/B;;GAEA,cAAc;GACd;KACE,8BAA8B;KAC9B,mBAAmB;KACnB,kBAAkB;KAClB,oCAAoC;KACpC,kBAAkB;KAClB,kBAAkB;GACpB;;GAEA;KACE,gBAAgB;KAChB,4BAA4B;GAC9B;;GAEA;KACE,kCAAkC;KAClC,mBAAmB;GACrB;;GAEA,sBAAsB;GACtB;KACE,8BAA8B;KAC9B,mBAAmB;KACnB,kBAAkB;KAClB,oCAAoC;KACpC,mBAAmB;KACnB,mBAAmB;GACrB;;GAEA,gBAAgB;GAChB;KACE,mBAAmB;KACnB,gBAAgB;KAChB,uBAAuB;KACvB,mBAAmB;KACnB,sBAAsB;KACtB,kBAAkB;GACpB;;GAEA;KACE,6BAA6B;KAC7B,kBAAkB;KAClB,iBAAiB;KACjB,mCAAmC;KACnC,kBAAkB;KAClB,kBAAkB;KAClB,kBAAkB;KAClB,wBAAwB;GAC1B;;GAEA;KACE,8BAA8B;KAC9B,gBAAgB;KAChB,iBAAiB;KACjB,cAAc;KACd,gBAAgB;GAClB;;GAEA,kDAAkD;GAClD;KACE,oBAAoB;KACpB,yBAAyB;KACzB,iCAAiC;KACjC,oBAAoB;KACpB,oBAAoB;KACpB,mBAAmB;KACnB,+BAA+B;KAC/B,oBAAoB;KACpB,mBAAmB;KACnB,uBAAuB;KACvB,sBAAsB;KACtB,qBAAqB;KACrB,+CAA+C;GACjD;;GAEA;KACE,mBAAmB;KACnB,4BAA4B;GAC9B;;GAEA;KACE,wBAAwB;GAC1B;;GAEA,+DAA+D;GAC/D;KACE,YAAY,qCAAqC,EAAE;KACnD,YAAY,uBAAuB,EAAE;GACvC;;GAEA;KACE,YAAY,0BAA0B,EAAE;KACxC,YAAY,uBAAuB,EAAE;KACrC,oBAAoB,eAAe,EAAE;KACrC,oBAAoB,eAAe,EAAE;KACrC,oBAAoB,eAAe,EAAE;KACrC,oBAAoB,aAAa,EAAE;GACrC","sourcesContent":["/* ============================================================\n   TutorialsDashboard.css  —  KinetiQ Tutorials Landing Page\n   Udemy-inspired design: Inter font throughout, hover popup card\n   ============================================================ */\n\n   @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');\n\n   /* ─── Design Tokens ──────────────────────────────────────── */\n   :root {\n     --tdb-bg:            #f7f9fa;\n     --tdb-surface:       #ffffff;\n     --tdb-border:        #d1d7dc;\n     --tdb-border-light:  #e8ecef;\n     --tdb-accent:        #28a745;\n     --tdb-accent-hover:  #1e8c3a;\n     --tdb-accent-glow:   rgba(40, 167, 69, 0.15);\n     --tdb-purple:        #5624d0;\n     --tdb-purple-light:  rgba(86, 36, 208, 0.07);\n     --tdb-purple-border: rgba(86, 36, 208, 0.18);\n     --tdb-amber:         #b4690e;\n     --tdb-amber-bg:      #f3e9d0;\n     --tdb-text:          #1c1d1f;\n     --tdb-text-muted:    #4a4f5a;\n     --tdb-text-dim:      #6a6f73;\n     --tdb-font:          'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n   }\n   \n   /* ─── Page wrapper ───────────────────────────────────────── */\n   .tdb-page {\n     background:  var(--tdb-bg);\n     min-height:  100%;\n     padding:     52px 64px 88px;\n     font-family: var(--tdb-font);\n     color:       var(--tdb-text);\n     overflow-y:  auto;\n     overflow-x:  hidden;\n     box-sizing:  border-box;\n     position:    relative;\n     animation:   tdb-fadeIn 0.25s ease;\n   }\n   \n   @keyframes tdb-fadeIn {\n     from { opacity: 0; transform: translateY(8px); }\n     to   { opacity: 1; transform: translateY(0); }\n   }\n   \n   /* ─── Page header ────────────────────────────────────────── */\n   .tdb-header {\n     max-width:      900px;\n     margin-bottom:  36px;\n     border-bottom:  2px solid var(--tdb-text);\n     padding-bottom: 20px;\n   }\n   \n   .tdb-header-tag {\n     font-family:    var(--tdb-font);\n     font-size:      13px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--tdb-purple);\n     margin-bottom:  10px;\n   }\n   \n   .tdb-header-title {\n     font-family:     var(--tdb-font);\n     font-size:       32px;\n     font-weight:     800;\n     color:           var(--tdb-text);\n     margin-bottom:   12px;\n     line-height:     1.2;\n     letter-spacing:  -0.5px;\n   }\n   \n   .tdb-header-desc {\n     font-family: var(--tdb-font);\n     color:       var(--tdb-text-muted);\n     font-size:   16px;\n     font-weight: 400;\n     line-height: 1.7;\n     max-width:   640px;\n     margin:      0;\n   }\n   \n   /* ─── Card grid ──────────────────────────────────────────── */\n   .tdb-grid {\n     display:               grid;\n     grid-template-columns: repeat(3, 1fr);\n     gap:                   20px;\n   }\n   \n   /* ─── Individual card ────────────────────────────────────── */\n   .tdb-card {\n     background:     var(--tdb-surface);\n     border:         1px solid var(--tdb-border);\n     border-radius:  6px;\n     padding:        20px 20px 16px;\n     cursor:         pointer;\n     text-align:     left;\n     display:        flex;\n     flex-direction: column;\n     gap:            12px;\n     transition:     box-shadow 0.2s, transform 0.15s, border-color 0.15s;\n     box-shadow:     0 2px 6px rgba(0, 0, 0, 0.06);\n     font-family:    var(--tdb-font);\n     color:          var(--tdb-text);\n     appearance:     none;\n     -webkit-appearance: none;\n     border-style:   solid;\n   }\n   \n   .tdb-card:hover,\n   .tdb-card--active {\n     box-shadow:   0 8px 28px rgba(0, 0, 0, 0.13);\n     transform:    translateY(-4px);\n     border-color: var(--tdb-purple);\n   }\n   \n   .tdb-card:focus-visible {\n     outline:        2px solid var(--tdb-accent);\n     outline-offset: 3px;\n   }\n   \n   .tdb-card-top {\n     display:         flex;\n     align-items:     flex-start;\n     justify-content: space-between;\n   }\n   \n   .tdb-card-icon {\n     font-size:       22px;\n     background:      #f3f4fd;\n     border:          1px solid #ddd6f8;\n     border-radius:   6px;\n     width:           48px;\n     height:          48px;\n     display:         flex;\n     align-items:     center;\n     justify-content: center;\n     flex-shrink:     0;\n   }\n   \n   .tdb-card-arrow {\n     width:           32px;\n     height:          32px;\n     border-radius:   50%;\n     background:      var(--tdb-accent);\n     color:           #fff;\n     display:         flex;\n     align-items:     center;\n     justify-content: center;\n     font-size:       16px;\n     font-weight:     700;\n     flex-shrink:     0;\n     transition:      background 0.2s, transform 0.2s;\n   }\n   \n   .tdb-card:hover .tdb-card-arrow,\n   .tdb-card--active .tdb-card-arrow {\n     background: var(--tdb-accent-hover);\n     transform:  translateX(3px);\n   }\n   \n   .tdb-card-body { flex: 1; }\n   \n   .tdb-card-title {\n     font-family:    var(--tdb-font);\n     font-size:      17px;\n     font-weight:    700;\n     color:          var(--tdb-text);\n     margin-bottom:  8px;\n     line-height:    1.35;\n     letter-spacing: -0.1px;\n   }\n   \n   .tdb-card-desc {\n     font-family: var(--tdb-font);\n     font-size:   14px;\n     font-weight: 400;\n     color:       var(--tdb-text-muted);\n     line-height: 1.65;\n     margin:      0;\n   }\n   \n   .tdb-card-footer {\n     border-top:  1px solid var(--tdb-border-light);\n     padding-top: 12px;\n     margin-top:  2px;\n   }\n   \n   .tdb-card-tag {\n     font-family:    var(--tdb-font);\n     font-size:      12px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.8px;\n     color:          var(--tdb-purple);\n     background:     var(--tdb-purple-light);\n     border:         1px solid var(--tdb-purple-border);\n     border-radius:  4px;\n     padding:        3px 10px;\n   }\n   \n   /* ─── Hover Popup — Udemy-style ──────────────────────────── */\n   .tdb-popup {\n     position:      fixed;\n     z-index:       1000;\n     width:         340px;\n     background:    var(--tdb-surface);\n     border:        1px solid var(--tdb-border);\n     border-radius: 6px;\n     box-shadow:    0 4px 32px rgba(0, 0, 0, 0.18);\n     padding:       20px;\n     font-family:   var(--tdb-font);\n     color:         var(--tdb-text);\n     animation:     tdb-popupIn 0.15s ease;\n     pointer-events: auto;\n   }\n   \n   @keyframes tdb-popupIn {\n     from { opacity: 0; transform: scale(0.97); }\n     to   { opacity: 1; transform: scale(1); }\n   }\n   \n   .tdb-popup-title {\n     font-family:    var(--tdb-font);\n     font-size:      18px;\n     font-weight:    800;\n     color:          var(--tdb-text);\n     line-height:    1.3;\n     letter-spacing: -0.3px;\n     margin-bottom:  12px;\n   }\n   \n   /* Badges row */\n   .tdb-popup-badges {\n     display:       flex;\n     gap:           8px;\n     margin-bottom: 12px;\n     flex-wrap:     wrap;\n   }\n   \n   .tdb-badge {\n     font-family:    var(--tdb-font);\n     font-size:      12px;\n     font-weight:    700;\n     border-radius:  4px;\n     padding:        3px 9px;\n     display:        inline-flex;\n     align-items:    center;\n     gap:            4px;\n     letter-spacing: 0.2px;\n   }\n   \n   .tdb-badge--premium {\n     background: var(--tdb-purple);\n     color:      #fff;\n     border:     1px solid var(--tdb-purple);\n   }\n   \n   .tdb-badge--bestseller {\n     background: var(--tdb-amber-bg);\n     color:      var(--tdb-amber);\n     border:     1px solid #e0c080;\n   }\n   \n   /* Meta rows */\n   .tdb-popup-meta {\n     font-family:   var(--tdb-font);\n     font-size:     13px;\n     font-weight:   400;\n     color:         var(--tdb-text-muted);\n     margin-bottom: 4px;\n     line-height:   1.5;\n   }\n   \n   .tdb-popup-meta strong {\n     font-weight: 700;\n     color:       var(--tdb-text);\n   }\n   \n   .tdb-popup-meta--dim {\n     color:         var(--tdb-text-dim);\n     margin-bottom: 12px;\n   }\n   \n   /* Short description */\n   .tdb-popup-desc {\n     font-family:   var(--tdb-font);\n     font-size:     14px;\n     font-weight:   400;\n     color:         var(--tdb-text-muted);\n     line-height:   1.65;\n     margin-bottom: 14px;\n   }\n   \n   /* Bullet list */\n   .tdb-popup-bullets {\n     list-style:    none;\n     padding:       0;\n     margin:        0 0 18px;\n     display:       flex;\n     flex-direction: column;\n     gap:           9px;\n   }\n   \n   .tdb-popup-bullets li {\n     font-family:  var(--tdb-font);\n     font-size:    13px;\n     font-weight:  400;\n     color:        var(--tdb-text-muted);\n     line-height:  1.55;\n     display:      flex;\n     gap:          10px;\n     align-items:  flex-start;\n   }\n   \n   .tdb-popup-check {\n     color:       var(--tdb-accent);\n     font-weight: 700;\n     font-size:   14px;\n     flex-shrink: 0;\n     margin-top:  1px;\n   }\n   \n   /* CTA button — Udemy purple \"Add to cart\" style */\n   .tdb-popup-cta {\n     width:          100%;\n     padding:        12px 16px;\n     background:     var(--tdb-purple);\n     color:          #fff;\n     border:         none;\n     border-radius:  4px;\n     font-family:    var(--tdb-font);\n     font-size:      15px;\n     font-weight:    700;\n     cursor:         pointer;\n     text-align:     center;\n     letter-spacing: 0.2px;\n     transition:     background 0.2s, transform 0.1s;\n   }\n   \n   .tdb-popup-cta:hover {\n     background: #4019a8;\n     transform:  translateY(-1px);\n   }\n   \n   .tdb-popup-cta:active {\n     transform: translateY(0);\n   }\n   \n   /* ─── Responsive ─────────────────────────────────────────── */\n   @media (max-width: 1100px) {\n     .tdb-grid { grid-template-columns: repeat(2, 1fr); }\n     .tdb-page { padding: 40px 40px 64px; }\n   }\n   \n   @media (max-width: 640px) {\n     .tdb-grid { grid-template-columns: 1fr; }\n     .tdb-page { padding: 28px 20px 52px; }\n     .tdb-header-title { font-size: 26px; }\n     .tdb-header-desc  { font-size: 15px; }\n     .tdb-card-title   { font-size: 16px; }\n     .tdb-popup        { display: none; }\n   }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
